<template>
  <div class="container">
    <van-sticky>
      <van-dropdown-menu active-color="#1989fa" :close-on-click-outside="false">
        <van-dropdown-item
          v-model="stateValue"
          :options="stateOptions"
          @change="sbcChargeRecordList(true)"
        />
        <van-dropdown-item
          ref="dateDropdown"
          @open="openSelDate"
          :title="dateDropdownTitle"
        >
          <van-cell center>
            <template #right-icon>
              <div class="date-box">
                <div class="date-box-btns">
                  <div class="date-box-btns-l">
                    <span class="date-box-title">交易日期</span>
                    <van-button size="mini" @click="resetDateSel"
                      >重置</van-button
                    >
                  </div>

                  <div class="date-box-btns-r">
                    <van-button
                      :color="activefastSel === 0 ? '#0173FF' : ''"
                      size="small"
                      @click="clickFastSel(0)"
                      >今日</van-button
                    >

                    <van-button
                      size="small"
                      :color="activefastSel === -1 ? '#0173FF' : ''"
                      @click="clickFastSel(-1)"
                      >昨日</van-button
                    >
                  </div>
                </div>
                <div class="date-box-sel">
                  <div>
                    <span class="date-box-title">时间段</span
                    ><span style="color: #999">(最多90天)</span>
                  </div>

                  <div class="date-box-sel-ipt">
                    <van-button
                      block
                      size="small"
                      @click="
                        selDateShow = true;
                        clickDateStart = true;
                      "
                      >{{
                        currentDate.start
                          ? currentDate.start.format("YYYY-MM-DD")
                          : "开始时间"
                      }}</van-button
                    >

                    <div class="sel-ipt-split">至</div>

                    <van-button
                      block
                      size="small"
                      @click="
                        selDateShow = true;
                        clickDateStart = false;
                      "
                      >{{
                        currentDate.end
                          ? currentDate.end.format("YYYY-MM-DD")
                          : "结束时间"
                      }}</van-button
                    >
                  </div>
                </div>
              </div>
            </template>
          </van-cell>

          <div class="date-box-footer">
            <van-button
              block
              round
              color="linear-gradient(to right, #0173FF, #5FD2FF)"
              @click="confirmDateFilter"
            >
              提交筛选
            </van-button>
          </div>
        </van-dropdown-item>
      </van-dropdown-menu>
    </van-sticky>

    <van-action-sheet v-model="selDateShow">
      <van-datetime-picker
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="selDateShow = false"
        @confirm="confirmSelDate"
      />
    </van-action-sheet>

    <van-list
      class="main-box"
      v-model="loading"
      :offset="100"
      :finished="!hasMore"
      finished-text="没有更多了"
      @load="sbcChargeRecordList"
    >
      <div
        class="main-box-item"
        v-for="item in recordList"
        :key="item.orderno"
        @click="
          toUrl(
            '/pages/superBusinessCard/ExchangeDetails?orderno=' + item.orderno
          )
        "
      >
        <div class="main-box-item-t">
          <div class="item-t-title">
            {{ item.faceValueCent / 100 }}积分
          </div>
          <div
            class="item-t-state"
            :style="{
              color:
                item.payStatus === 3
                  ? '#62605f'
                  : stateMap[item.chargeStatus].color,
            }"
          >
            {{
              item.payStatus === 3 ? "已退款" : item.chargeStatus == 0 ? payStatusOpt.find(target => target.value === item.payStatus).label : stateMap[item.chargeStatus].text
            }}
          </div>
        </div>
        <div class="main-box-item-b">
          <div class="item-b-date">{{ item.createTime }} 下单</div>
          <div class="item-b-point">{{ item.pricePoint }}票</div>
        </div>
      </div>
    </van-list>

    <div class="footer-btns">
      <van-button
        block
        round
        @click="toUrl('/pages/superBusinessCard/ExchangeCard')"
      >
        去兑换
      </van-button>

      <van-button
        class="open-miniapp-btn"
        block
        round
        color="linear-gradient(to top, #FE0335, #FF7366)"
      >
        <div class="launch-btn"></div>
        去消费
      </van-button>
    </div>
  </div>
</template>
<script>
import api from "../../api";
import dayjs from "dayjs";

export default {
  title: "我的超商联盟",
  data() {
    return {
      recordList: [],
      hasMore: true,
      lastId: "",
      loading: false,

      stateValue: "",
      stateOptions: [
        { text: "全部状态", value: "" },
        { text: "成功兑换", value: 2 },
        { text: "兑换中", value: 0 },
        { text: "待人工处理", value: 4 },
        { text: "已退款", value: 3 },
      ],
      stateMap: {
        0: {
          text: "兑换中",
          color: "#3377ff",
        },
        2: {
          text: "成功",
          color: "#15ba11",
        },
        3: {
          text: "已退款",
          color: "#62605f",
        },
        4: {
          text: "待人工处理",
          color: "#ff5437",
        },
      },

      selDateShow: false,
      clickDateStart: true,
      minDate: dayjs()
        .subtract(89, "day")
        .toDate(),
      maxDate: new Date(),
      oldCurrentDate: {
        start: null,
        end: null,
      },
      currentDate: {
        start: null,
        end: null,
      },
      payStatusOpt: [
        { value: 0, label: '待支付' },
        { value: 1, label: '已支付' },
        { value: 2, label: '支付失败' },
        { value: 3, label: '已退款' },
      ],
      settings: {},
    };
  },
  created() {
    this.sbcChargeRecordList(true);
    api.superBusinessCard.sbcChargeSetting(data => {
      console.log(data, "超商卡设置***");
      this.settings = data;
      const box = this.$el.querySelector(".launch-btn");
      this.wx_launch({
        ele: this.$el,
        // appid: "wx2b4c74af074f2085",
        appid: this.settings.miniProgramId,
        content: `<div class="test-btn"></div>
        <style>
        .test-btn{
            width: ${box.clientWidth}px;
            height: ${box.clientHeight}px;
          }
        </style>`,
      });
    });
  },
  mounted() {
  },
  computed: {
    activefastSel() {
      if (
        this.currentDate.start &&
        this.currentDate.end &&
        this.currentDate.start.isSame(this.currentDate.end, "day")
      ) {
        let curr = dayjs();
        if (curr.isSame(this.currentDate.start, "day")) {
          return 0;
        } else if (
          curr.subtract(1, "day").isSame(this.currentDate.start, "day")
        ) {
          return -1;
        } else {
          return -9999;
        }
      } else {
        return -9999;
      }
    },
    dateDropdownTitle() {
      if (this.oldCurrentDate.start && this.oldCurrentDate.end) {
        return (
          this.oldCurrentDate.start.format("YYYY-MM-DD") +
          " ~ " +
          this.oldCurrentDate.end.format("YYYY-MM-DD")
        );
      } else {
        return "选择日期";
      }
    },
  },
  methods: {
    is_weixn() {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    is_version() {
      const wxInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i); // 微信浏览器信息
      // 微信正常版本号 wxInfo[1] = "8.0.1840" (示例)
      // 微信异常版本号 wxInfo[1] = "8.0.1.1840" (示例)
      //进行split转成数组进行判断 ['8','0','1','1840'] (示例)
      const version = wxInfo[1].split(".");
      // console.log('version', version);
      // 判断版本在7.0.12及以上的版本
      if (Number(version[0]) > 7) {
        return true;
      } else if (Number(version[0]) === 7) {
        if (Number(version[1]) > 0) {
          return true;
        } else if (Number(version[1]) === 0) {
          if (Number(version[2]) >= 12) return true;
        }
      }
      return false;
    },
    /* 
    {
        ele:"", // 元素ID
        appid:"", // 小程序id号 wx_****
        username: "", // gh_**** 
        url:"", // 跳转小程序的页面路径地址 例: pages/home/home.html - (后面必须带上.html后缀 否则IOS跳转时出现小程序页面未配置)
        content:"" // html字符串 例: "<button>点我</button>"
    }
  */
    wx_launch(info) {
      if (!this.is_weixn()) return;
      if (this.is_version) {
        const btn = info.ele.querySelector(".launch-btn"); //获取元素
        const script = document.createElement("script"); // 创建script内容插槽 避免template标签冲突
        script.type = "text/wxtag-template"; // 使用script插槽 必须定义这个type
        script.text = info.content; // 自定义的html字符串内容
        const html = `<wx-open-launch-weapp
                      style="display: block;width: 100%;height: 100%" 
                      appid="${info.appid}">${script.outerHTML}</wx-open-launch-weapp>`;
        btn.innerHTML = html; // html字符串赋值
      } else {
        alert("您的版本号不支持");
      }
    },
    toUrl(url) {
      this.$routerPush(this, url);
    },
    sbcChargeRecordList(reset = false) {
      let params = {
        startTime:
          dayjs()
            .subtract(89, "day")
            .format("YYYY-MM-DD") + " 00:00:00",
        endTime:
          dayjs()
            .add(1, "day")
            .format("YYYY-MM-DD") + " 00:00:00",
        limit: 10,
      };
      if (this.oldCurrentDate.start && this.oldCurrentDate.end) {
        params.startTime =
          this.oldCurrentDate.start.format("YYYY-MM-DD") + " 00:00:00";
        params.endTime =
          this.oldCurrentDate.end.add(1, "day").format("YYYY-MM-DD") +
          " 00:00:00";
      }

      if (!reset && this.lastId) params.lastId = this.lastId;
      if (this.stateValue !== "") {
        if (this.stateValue === 3) {
          params.payStatus = 3;
        } else {
          params.chargeStatus = this.stateValue;
        }
      }
      this.loading = true;
      api.superBusinessCard.sbcChargeRecordList(
        params,
        data => {
          this.loading = false;
          console.log(data, "直充记录列表***");
          if (reset) {
            this.recordList = data.records;
          } else {
            this.recordList = this.recordList.concat(data.records);
          }
          this.hasMore = data.hasMore;
          this.lastId = data.lastId;
        },
        err => {
          this.$toast(err.msg);
          this.loading = false;
        }
      );
    },
    openSelDate() {
      this.currentDate.start = this.oldCurrentDate.start;
      this.currentDate.end = this.oldCurrentDate.end;
    },
    resetDateSel() {
      this.currentDate.start = null;
      this.currentDate.end = null;
    },
    clickFastSel(type) {
      if (type === 0) {
        this.currentDate.start = this.currentDate.end = dayjs();
      } else if (type === -1) {
        this.currentDate.start = this.currentDate.end = dayjs().subtract(
          1,
          "day"
        );
      }
    },
    confirmSelDate(val) {
      if (this.clickDateStart) {
        if (
          this.currentDate.end &&
          dayjs(val).isAfter(this.currentDate.end, "day")
        ) {
          this.$toast("请选择正确的时间范围！");
          return;
        }
        this.currentDate.start = dayjs(val);
      } else {
        if (
          this.currentDate.start &&
          this.currentDate.start.isAfter(dayjs(val), "day")
        ) {
          this.$toast("请选择正确的时间范围！");
          return;
        }
        this.currentDate.end = dayjs(val);
      }
      this.selDateShow = false;
    },
    confirmDateFilter() {
      if (this.currentDate.start && this.currentDate.end) {
        this.oldCurrentDate.start = this.currentDate.start;
        this.oldCurrentDate.end = this.currentDate.end;
        this.sbcChargeRecordList(true);
        if (this.$refs["dateDropdown"])
          this.$refs["dateDropdown"].toggle(false);
      } else if (!this.currentDate.start && !this.currentDate.end) {
        this.oldCurrentDate.start = null;
        this.oldCurrentDate.end = null;
        this.sbcChargeRecordList(true);
        if (this.$refs["dateDropdown"])
          this.$refs["dateDropdown"].toggle(false);
      } else {
        this.$toast("请选择完整的时间范围");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.open-miniapp-btn {
  position: relative;
  .launch-btn {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
}
.container {
  background-color: #fbfbfd;
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: calc(22.67vw + constant(safe-area-inset-bottom));
  padding-bottom: calc(22.67vw + env(safe-area-inset-bottom));

  /deep/ .van-dropdown-menu__bar {
    padding: 0 6.67vw 0 4vw;
    .van-dropdown-menu__item:first-child {
      justify-content: flex-start;
      flex: 0 1 auto;
    }
    .van-dropdown-menu__item:last-child {
      justify-content: flex-end;
      flex: 1 1 auto;
    }
  }

  .date-box {
    padding: 2.67vw 0;
    width: 100%;
    .date-box-title {
      font-weight: 600;
      font-size: 4vw;
      margin-right: 2.67vw;
    }

    .date-box-btns {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .date-box-btns-l {
        display: flex;
        align-items: center;
      }
      .date-box-btns-r {
        .van-button {
          padding: 0 4vw;
          border-radius: 1.33vw;
        }
      }
    }
    .date-box-sel {
      margin-top: 4vw;
      .date-box-sel-ipt {
        margin-top: 2vw;
        display: flex;
        align-items: center;
        .van-button {
          flex: 1;
          border-radius: 1.33vw;
          color: #666;
          background-color: #f5f5f5;
          border-color: #f5f5f5;
        }
        .sel-ipt-split {
          margin: 0 2.67vw;
        }
      }
    }
  }
  .date-box-footer {
    padding: 4vw;
    .van-button {
      width: 40%;
      margin: 0 auto;
    }
  }

  .main-box {
    padding: 4vw;
    .main-box-item {
      padding: 4vw;
      overflow: hidden;
      background-color: #fff;
      box-shadow: 0 0 0.4vw rgba(200, 200, 200, 0.3);
      border-radius: 1.33vw;
      & + .main-box-item {
        margin-top: 4vw;
      }
      .main-box-item-t {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item-t-title {
          font-weight: 600;
        }
        .item-t-state {
          font-size: 3.47vw;
        }
      }
      .main-box-item-b {
        margin-top: 3.33vw;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item-b-date {
          color: #999;
          font-size: 3.47vw;
        }
        .item-b-point {
          font-weight: 600;
        }
      }
    }
  }

  .footer-btns {
    position: fixed;
    left: 0;
    right: 0;
    bottom: calc(0px + constant(safe-area-inset-bottom));
    bottom: calc(0px + env(safe-area-inset-bottom));
    padding: 0 2.67vw 10.67vw;
    display: flex;
    justify-content: center;
    .van-button {
      margin: 0 2.67vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/superBusinessCard/MyCard.vue